"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogRoot = exports.CopyLinkInputButton = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _CopyLinkInputWithButton = require("../CopyLinkInputWithButton");
const DialogRoot = exports.DialogRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  [`& .${_components.dialogClasses.header}`]: {
    paddingBottom: theme.spacing(6)
  },
  [`& .${_components.dialogClasses.content}`]: {
    maxWidth: 540
  }
}));
const CopyLinkInputButton = exports.CopyLinkInputButton = (0, _mui.styled)(_CopyLinkInputWithButton.CopyLinkInputButton)(({
  theme
}) => ({
  margin: theme.spacing(3, 0)
}));
//# sourceMappingURL=styles.js.map